 
import { Injectable } from '@angular/core';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';

/* @vite-ignore */
GlobalWorkerOptions.workerSrc = '/assets/pdfjs-workers/pdf.worker.mjs';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  async extractTextFromPDF(content: ArrayBuffer): Promise<string> {
    const pdf = await getDocument({ data: content }).promise;
    let extractedText = '';

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const textContent = await page.getTextContent();
      extractedText +=
        textContent.items.map((item: any) => item.str).join(' ') + '\n';
    }

    return extractedText;
  }
}
